export function mailSupportListGet(page, callback) {
	return {
    type: 'MAIL_SUPPORT_LIST_GET',
		payload: {
			page: page,
		},
		callback: callback,
	}
}
